import { Box, Flex } from "@chakra-ui/react";
import { Sidebar } from "@root/components/dashboard/sidebar";
import React from "react";
import { Outlet } from "react-router-dom";
import { DashboardLayoutContainter } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { filePopOverHandler } from "@root/store/slices/entities";
import { getFilePopOver } from "@root/store/selectors/entities";

const DashboardLayout: React.FC = () => {
  const dispatch = useDispatch();
  const filePopOverStatus: boolean = useSelector(getFilePopOver);
  const globalClickHandlet = () => {
    if (filePopOverStatus) {
      dispatch(filePopOverHandler(false));
    }
  };
  return (
    <DashboardLayoutContainter onClick={globalClickHandlet}>
      <Flex flex={1} width={"100%"}>
        <Box className="left-box" borderRight={"1px solid #D9D9D9"}>
          <Sidebar />
        </Box>
        <Box
          overflow={"auto"}
          className="right-box"
          flex={1}
          bgColor={"#F5F5F5"}
        >
          <Outlet />
        </Box>
      </Flex>
    </DashboardLayoutContainter>
  );
};

export default DashboardLayout;
